export default __webpack_public_path__ + "static/media/3、首页多多柠檬茶.4d98b187.jpg";